import { createFeatureSelector, createSelector } from '@ngrx/store'
import { StoreKeysEnum } from '../../../../store/store-keys'
import { IUserContextState } from './user-context.reducers'
import cloneDeep from 'lodash/cloneDeep'

export const selectUserContext =
    createFeatureSelector<Readonly<IUserContextState>>(StoreKeysEnum.CommonUserContext)

export const selectProjectKey = createSelector(
    selectUserContext,
    (data) => data?.project?.key
)

export const selectProject = createSelector(
    selectUserContext,
    (data) => cloneDeep(data?.project)
)

export const selectProjectKeys = createSelector(
    selectUserContext,
    (data) => cloneDeep(data?.projectKeys)
)

export const selectProjects = createSelector(
    selectUserContext,
    (data) => cloneDeep(data?.projects)
)

export const selectUser = createSelector(
    selectUserContext,
    (data) => cloneDeep(data?.user)
)

export const selectUserName = createSelector(
    selectUserContext,
    (data) => data?.user.name
)